import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import f1 from './images/f1.jpg';
import f2 from './images/f2.jpg';
import f3 from './images/f3.jpg';

function Testimonial() {
	return (
		<div>
			<section>
				<Container>
					<Row>
						<Col>
							<br />
							<br />
							<div className="slogan-1 display-4 text-center">Testimonials</div>
							<br />
							<hr class="descript-user " />
							<br />
							<Carousel indicators={false} fade={true} interval={4000}>
								<Carousel.Item>
									<div class="container">
										<div class="row justify-content-center">
											<div class="col-xs-4 my-auto">
												<img src={f1} alt="image-pic" class="tes-pic" />
											</div>
										</div>
									</div>
									<br />
									<br />
									<div class="container">
										<div class="row justify-content-center">
											<div class="col-9">
												<p class="text-center">
													I loved how these guys professionally handled the pick & drop,repair and drop. I would espically appreciate the transparency shown while repair job and focus on customer experience
												</p>
											</div>
										</div>
									</div>
								</Carousel.Item>
								<Carousel.Item>
									<div class="container">
										<div class="row justify-content-center">
											<div class="col-xs-4 my-auto">
												<img src={f2} alt="image-pic" class="tes-pic" />
											</div>
										</div>
									</div>
									<br />
									<br />
									<div class="container">
										<div class="row justify-content-center">
											<div class="col-9">
												<p class="text-center">
													Loved how they handled my Trek bike and could do a super quick turnaround
												</p>
											</div>
										</div>
									</div>
								</Carousel.Item>
								<Carousel.Item>
									<div class="container">
										<div class="row justify-content-center">
											<div class="col-xs-4 my-auto">
												<img src={f3} alt="image-pic" class="tes-pic" />
											</div>
										</div>
									</div>
									<br />
									<br />
									<div class="container">
										<div class="row justify-content-center">
											<div class="col-9">
												<p class="text-center">
													I did a walk in at their service center and was impressed with quality of the tools and spares
												</p>
											</div>
										</div>
									</div>
								</Carousel.Item>
							</Carousel>
						</Col>
					</Row>
				</Container>
			</section>
		</div>
	);
}

export default Testimonial;
